import { Component } from '@angular/core';
import { CreateCityComponent } from '../../../../components/admin-dashboard-component/cities/create-city-component/create-city-component';

@Component({
  selector: 'app-create-city',
  imports: [CreateCityComponent],
  templateUrl: './create-city.html',
  styleUrl: './create-city.scss',
})
export class CreateCity {

}
